import { httpClient } from '../httpClient';
import {
  UserResponse,
  UpdateProfileRequest,
  ChangePasswordRequest,
  UserLoginDeviceResponse,
} from '@packages/global';

/**
 * 用户资料 API 模块
 * 处理用户个人信息管理操作
 */
export class ProfileApi {

  /**
   * 更新个人资料
   */
  async updateProfile(data: UpdateProfileRequest): Promise<UserResponse> {
    return httpClient.put<UserResponse>('/user/profile/info', data);
  }

  /**
   * 修改密码
   */
  async changePassword(data: ChangePasswordRequest): Promise<void> {
    return httpClient.put<void>('/user/profile/password', data);
  }

  async getLoginDevices(): Promise<UserLoginDeviceResponse[]> {
    return httpClient.get<UserLoginDeviceResponse[]>('/user/profile/login-devices');
  }

}

// 导出单例实例
export const profileApi = new ProfileApi();
